export class WhatsAppOfficialTemplateVariable {
  public component_type: string;
  public index: number;
  public name: string;
  public label: string;

  constructor() { }
}

export class WhatsAppOfficialTemplate {
  public name: string;
  public language: string;
  public status: string;
  public category: string;
  public components: any[];
  public variables: WhatsAppOfficialTemplateVariable[];

  constructor() { }
}

